// Small localStorage cache for API responses, so prototyping does not hit
// the real API on every load. Controlled via env:
//   VITE_API_CACHE=false     -> disable caching, always pull live content
//   VITE_API_CACHE_TTL=900   -> cache lifetime in seconds (default 15 min)
const CACHE_PREFIX = 'its-my-news:api:';

const isEnabled = import.meta.env.VITE_API_CACHE !== 'false';
const ttlMs = Number(import.meta.env.VITE_API_CACHE_TTL || 900) * 1000;

export function readCache(key) {
  if (!isEnabled) return null;

  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;

    const { expiresAt, data } = JSON.parse(raw);
    if (Date.now() > expiresAt) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }

    return data;
  } catch {
    return null;
  }
}

export function writeCache(key, data) {
  if (!isEnabled) return;

  try {
    localStorage.setItem(
      CACHE_PREFIX + key,
      JSON.stringify({ expiresAt: Date.now() + ttlMs, data }),
    );
  } catch {
    // Storage full or unavailable: skip caching, the app still works live.
  }
}
